import { render } from "./billSaleReport.vue?vue&type=template&id=1ee99522"
import script from "./billSaleReport.vue?vue&type=script&lang=js"
export * from "./billSaleReport.vue?vue&type=script&lang=js"

import "./billSaleReport.vue?vue&type=style&index=0&id=1ee99522&lang=scss"

import exportComponent from "D:\\companyProject\\G10Product\\trunk\\Bestech.CloudPos\\Bestech.CloudPos.Portal\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__